import TrailerGridItem from './TrailerGridItem';

export default TrailerGridItem;
